module.exports = __webpack_public_path__ + "static/img/moaVersionView_pic03.c29a489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaVersionView/moaVersionView_pic03.png
// module id = 551
// module chunks = 1